import React from 'react'
import PropTypes from 'prop-types'
import c from 'classnames'
import { propTypes, defaultProps } from './props'

// DEPREACATED
export function SubHeading({ className, children, ...props }) {
  return <div className={c('sub-heading', className)}>{children}</div>
}
export default SubHeading

SubHeading.propTypes = {
  ...propTypes,
  className: PropTypes.string,
  children: PropTypes.node,
}

SubHeading.defaultProps = {
  ...defaultProps,
  className: '',
  children: null,
}
